import { render, staticRenderFns } from "./WidgetBarGraph.vue?vue&type=template&id=11bcaadf&scoped=true&"
import script from "./WidgetBarGraph.vue?vue&type=script&lang=js&"
export * from "./WidgetBarGraph.vue?vue&type=script&lang=js&"
import style0 from "./WidgetBarGraph.vue?vue&type=style&index=0&id=11bcaadf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bcaadf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11bcaadf')) {
      api.createRecord('11bcaadf', component.options)
    } else {
      api.reload('11bcaadf', component.options)
    }
    module.hot.accept("./WidgetBarGraph.vue?vue&type=template&id=11bcaadf&scoped=true&", function () {
      api.rerender('11bcaadf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/widgets/WidgetBarGraph.vue"
export default component.exports